import { frozen } from "mobx-keystone";
import { Cubby } from "../stores/Cubby";
import { notifications } from "@mantine/notifications";
import * as Sentry from "@sentry/react";
import { MODALS } from "./constants";

export const updatePayOffchainEvents = (
  cubby: Cubby,
  newPayOffchainEvents: any[]
) => {
  cubby.payOffchainEvents = frozen(newPayOffchainEvents);
  const possiblyPaid = newPayOffchainEvents.find(
    (event) =>
      event.eventKind === "confirmed" &&
      event.event.request === cubby.lastProposedLightningInvoiceForPayment
  );
  if (possiblyPaid) {
    console.log("invoice was likely paid");
    cubby.clearLightningInvoiceStringForPayment();
    notifications.show({
      color: "blue",
      title: "Payment Success",
      message:
        "An invoice for " +
        possiblyPaid.event.tokens.toLocaleString() +
        " satoshis was paid",
    });
  }

  if (cubby.payToLightningAddressInvoiceInPaymentProgress) {
    const possiblyPaid = newPayOffchainEvents.find(
      (event) =>
        event.eventKind === "confirmed" &&
        event.event.request ===
          cubby.payToLightningAddressInvoiceInPaymentProgress
    );
    if (possiblyPaid) {
      console.log("invoice was likely paid");
      cubby.setPayToLightningAddressInvoiceInPaymentProgress(null);
      notifications.show({
        color: "blue",
        title: "Payment Success",
        message:
          "A Lightning Address payment for " +
          possiblyPaid.event.tokens.toLocaleString() +
          " satoshis was paid",
      });
    }
  }
};

export const extractSenderMessage = (mostRecentInvoiceUpdateEvent) => {
  const paymentMessages =
    mostRecentInvoiceUpdateEvent.payments?.[0]?.messages || [];
  const messageType34349334 = paymentMessages.find(
    (msg) => msg.type === "34349334"
  );

  if (messageType34349334) {
    // console.log('found message type "34349334"');
    // Convert the hex value to text using Uint8Array and TextDecoder
    const hexValue = messageType34349334.value;
    const hexBytes = new Uint8Array(
      hexValue.match(/.{1,2}/g).map((byte) => parseInt(byte, 16))
    );
    const decoded = new TextDecoder().decode(hexBytes);
    // console.log("decoded message", decoded);
    return decoded;
  }

  return ""; // Default to an empty string if no message is found
};

export const updateInvoiceUpdateEvents = (
  cubby: Cubby,
  newInvoiceUpdateEvents: any[]
) => {
  cubby.invoiceUpdateEvents = frozen(newInvoiceUpdateEvents);
  const mostRecentInvoiceUpdateEvent = newInvoiceUpdateEvents[0];
  console.log("most recent update event", mostRecentInvoiceUpdateEvent);

  const { received, is_push, is_confirmed, description } =
    mostRecentInvoiceUpdateEvent;
  let message = "";
  if (is_confirmed) {
    const shouldContinue = cubby.makeBlockerOrReturnFalse(
      "incoming-lightning-payment",
      mostRecentInvoiceUpdateEvent.id
    );

    if (!shouldContinue) {
      console.log('returning because "incoming-lightning-payment" blocker');
      return;
    }

    console.log("mostRecentInvoiceUpdateEvent", mostRecentInvoiceUpdateEvent);
    console.log("tokens is", received);

    if (is_push === undefined) {
      console.log(`Payment of invoice for amount ${received} tokens`);
      console.log(
        "lastBolt11UserGeneratedPayRequest",
        cubby.lastBolt11UserGeneratedPayRequest
      );
      console.log(
        "mostRecentInvoiceUpdateEvent.request",
        mostRecentInvoiceUpdateEvent.request
      );
      if (
        mostRecentInvoiceUpdateEvent.request ==
        cubby.lastBolt11UserGeneratedPayRequest
      ) {
        cubby.resetUserGeneratedBolt11PayRequest();
        if (cubby.currentModal == MODALS.CREATE_INVOICE) {
          cubby.setModal(null);
        }
      }
      // if (!description) {
      //   message = `Inbound payment for ${received.toLocaleString()} satoshis received.`;
      // } else {
      //   message =
      //     "Inbound payment for " +
      //     received.toLocaleString() +
      //     " satoshis received. Message: " +
      //     '"' +
      //     description +
      //     '"';
      // }
      message = buildInboundPaymentMessage(received, description);
    } else if (is_push === true) {
      // Check for sender message in the messages array
      const senderMessage = extractSenderMessage(mostRecentInvoiceUpdateEvent);

      // Construct the message
      message = `You've received a keysend payment for ${received.toLocaleString()} satoshis.`;
      if (senderMessage) {
        message += ` Sender message: "${senderMessage}"`;
      }
    } else {
      console.log("This is not a confirmed payment, do nothing");
      return;
    }
    if (message.length > 0) {
      notifications.show({
        color: "blue",
        title: "Incoming payment",
        message: message,
      });
      /// this is duplicate, like rails already does this immediately after thinking there is an incoming payment
      // but there might be race conditions where LND doesn't show the payment yet in getchannels
      // .. i see this error on prod but not on dev, probably due to faster actions on prod
      /// so instead of being 100% sure, let just do it twice...
      cubby.cubbyLife("get_channels");
    }
  } else {
    console.log(" invoice update event not confirmed, do nothing");
  }
};

export const buildInboundPaymentMessage = (received, rawDescription) => {
  console.log("in buildInboundPaymentMessage");
  let parsedContent;

  try {
    // Attempt to parse JSON
    const parsedJson = JSON.parse(rawDescription);

    // Check if "content" exists and is nonempty
    if (parsedJson.content && parsedJson.content.trim() !== "") {
      parsedContent = parsedJson.content;
    } else {
      // Content is empty, so treat it as no description
      parsedContent = "";
    }
  } catch (error) {
    // Fallback to raw description if parsing fails
    Sentry.captureException(error, {
      tags: {
        function: "buildLedgerInboundPaymentMessage",
        action: "json_parsing",
      },
      contexts: {
        parsing_details: {
          rawDescription,
          received: received,
          descriptionLength: rawDescription?.length || 0,
          errorMessage: error?.message || "Unknown parsing error",
        },
      },
    });
    parsedContent = rawDescription;
  }

  let message;
  if (!parsedContent || parsedContent.trim() === "") {
    // No description
    message = `Inbound payment for ${received.toLocaleString()} satoshis received.`;
  } else {
    // Description present
    message = `Inbound payment for ${received.toLocaleString()} satoshis received. Message: "${parsedContent}"`;
  }

  return message;
};

export const buildLedgerInboundPaymentMessage = (received, rawDescription) => {
  // console.log("in buildLedgerInboundPaymentMessage");

  let result;
  try {
    const parsedJson = JSON.parse(rawDescription);

    // If "content" is present and non-blank, use it; otherwise return null
    if (parsedJson.content && parsedJson.content.trim() !== "") {
      result = parsedJson.content;
    } else {
      result = null;
    }
  } catch (error) {
    // If invalid JSON, just return the raw string
    // Sentry.captureException(error, {
    //   tags: {
    //     function: "buildLedgerInboundPaymentMessage",
    //     action: "json_parsing_ledger",
    //   },
    //   contexts: {
    //     parsing_details: {
    //       rawDescription,
    //       received: received,
    //       descriptionLength: rawDescription?.length || 0,
    //       errorMessage: error?.message || "Unknown parsing error",
    //     },
    //   },
    // });
    result = rawDescription;
  }

  return result;
};
